"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
const Chip_1 = __importDefault(require("@material-ui/core/Chip"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const react_1 = __importStar(require("react"));
const makeMyClasses = (props) => {
    var _a;
    return ({
        root: {
            maxWidth: '100%',
            width: props.fullWidth ? '100%' : 'auto',
            height: props.multiline ? 32 : props.small ? 22 : props.large ? 32 : 30,
            fontSize: props.multiline ? 12 : props.small ? 12 : 14,
            justifyContent: 'flex-start',
            backgroundColor: props.color.main,
            border: props.clickable && props.border ? `1px solid ${props.border.main}` : 'none',
            color: props.opacity < 1 ? props.color.main : props.color.contrastText,
            opacity: props.opacity || 1,
            textTransform: (_a = props.textTransform) !== null && _a !== void 0 ? _a : 'capitalize',
            cursor: 'inherit',
            '& .MuiChip-label': {
                lineHeight: props.multiline ? '14px' : '100%',
                margin: 'auto',
                whiteSpace: props.multiline ? 'initial' : undefined,
                textAlign: props.centered ? 'center' : undefined,
            },
            '&:hover, &:focus': props.clickable
                ? {
                    backgroundColor: props.color.light,
                    border: props.border ? `1px solid ${props.border.light}` : 'none',
                }
                : undefined,
        },
        disabled: {
            opacity: 0.4,
        },
        avatar: {
            backgroundColor: props.color.dark,
            color: props.color.contrastText,
        },
        deleteIcon: {
            color: props.color.contrastText + '50',
            marginLeft: -4,
            '&:hover': {
                color: props.color.contrastText + '70',
            },
        },
        icon: {
            color: props.color.contrastText,
        },
    });
};
exports.Chip = react_1.default.memo((props) => {
    const { style, icon, avatar, disabled = false, label, tip, onClick, onDelete, deleteIcon, classes, color = lib_palette_1.default.secondary, } = props;
    const clickable = !!onClick || !!onDelete;
    const myCss = (0, web_css_1.default)(makeMyClasses, [Object.assign({ color, clickable }, props)], classes);
    const chip = (0, react_1.useMemo)(() => (react_1.default.createElement(Chip_1.default, { style: style, classes: {
            root: myCss.root + ' newStyle' + ' ' + (disabled ? myCss.disabled : ''),
            deleteIcon: myCss.deleteIcon + ' newStyle',
            avatar: myCss.avatar + ' newStyle',
            icon: myCss.icon + ' newStyle',
        }, icon: icon, avatar: avatar, label: label, clickable: !disabled && !!onClick, onClick: disabled ? undefined : onClick, onDelete: disabled ? undefined : onDelete, deleteIcon: disabled ? undefined : deleteIcon })), [avatar, deleteIcon, disabled, icon, label, myCss, onClick, onDelete, style]);
    return tip ? (react_1.default.createElement(Tooltip_1.default, { tip: label, enterDelay: 400, style: style }, chip)) : (chip);
});
exports.default = exports.Chip;
